import { render, staticRenderFns } from "./todaySugar.vue?vue&type=template&id=3bbdba06&scoped=true"
import script from "./todaySugar.vue?vue&type=script&lang=js"
export * from "./todaySugar.vue?vue&type=script&lang=js"
import style0 from "./todaySugar.vue?vue&type=style&index=0&id=3bbdba06&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bbdba06",
  null
  
)

export default component.exports